// extracted by mini-css-extract-plugin
module.exports = {"rich-text":"RichText-module--rich-text--1vCJd","richText":"RichText-module--rich-text--1vCJd","image":"RichText-module--image--j6RSk"};